import React from 'react';
import {
  EdgeType,
  FlowType,
  GroupType,
  ItemType,
  NodeType,
} from '../../api/useEstatePlanningFlowQuery';
import { CustomHeader } from './FlowChart.styles';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';
import { NodesLoading } from './components/Nodes/Nodes.loading';
import { EdgeLoading } from './components/Edge/Edge.loading';
import { GroupLoading } from './components/Group/Group.loading';

const mockEstate = {
  type: ItemType.TaxesAndFees,
  value: 25_000,
};

const mockBeneficiaries = {
  type: ItemType.Beneficiaries,
  nameList: ['Carmen Martin', 'James Martin', 'Louis Martin'],
  value: 200_000,
};
const mockCharityBeneficiaries = {
  type: ItemType.CharityBeneficiaries,
  value: 50_000,
};
const mockDeceased = {
  type: ItemType.Principal,
  label: 'age 95 in 2036',
  nameList: ['Dean Martin'],
  value: 1_000_000,
};

export const loadingData = [
  {
    type: FlowType.Node,
    items: [mockEstate, mockBeneficiaries, mockCharityBeneficiaries],
  },
  {
    type: FlowType.Edge,
    title: 'DEAN’s Resources at PASSING',
    value: 1_000_000,
  },
  {
    type: FlowType.Group,
    groupItems: [
      {
        title: 'Estate',
        items: [
          {
            type: FlowType.Node,
            items: [mockDeceased],
          },
          {
            type: FlowType.Node,
            items: [mockEstate, mockBeneficiaries],
          },
        ],
      },
    ],
  },
] as (NodeType | EdgeType | GroupType)[];

export const FlowChartLoading = () => {
  return (
    <Box as="section" mb="40">
      <CustomHeader mb="40">
        <Box display="block" height="24px" width="100px" />
      </CustomHeader>

      {loadingData.map((flowData, flowDataIndex) => {
        const isFirst = flowDataIndex === 0;

        if (flowData.type === FlowType.Node) {
          return <NodesLoading key={flowDataIndex} items={flowData.items} isFirst={isFirst} />;
        }

        if (flowData.type === FlowType.Group) {
          return <GroupLoading groupItems={flowData.groupItems} key={flowDataIndex} />;
        }

        return <EdgeLoading key={flowDataIndex} />;
      })}
    </Box>
  );
};
